module.exports = __webpack_public_path__ + "72dd823c6307d709bd8a0deb109f2549.MP3";